module.exports = __webpack_public_path__ + "ceab213d8553bfa0d5deadd27f18a27e.jpg";